<template>
  <div class="content">
    <div class="mid">
      <initiate-process
          v-if="tptId"
          ref="processForm"
          :code="tptId"
          :instanceId="instanceId"
          :isAgainShenPi="isAgainShenPi"
          :againShenPi="againShenPi"
      ></initiate-process>
    </div>
    <div class="mid" style="padding-right: 0px;">
      <div class="title">流程</div>
      <el-timeline style="margin: 20px 0px 0px 14px;">
        <el-timeline-item :timestamp="i.name" v-for="(i, index) in InitFlowNodeList" :key="index">
          {{ i.nodeName }}
          <div class="markBox">
            <span v-for="(j, k) in i.makers.split(',')" :key="k" class="Name" style="display: inline-block;"
            >{{ j | returnFloat }} <span style="color:#1e1e1e;">{{ j }}</span>
            </span>
          </div>
          <!-- 单选 -->
          <el-dropdown style="float: right" trigger="click" @command="handleCommand" v-if="i.selectMode == 1">
            <span class="el-dropdown-link">
              <el-button
                  @click="handelApproval"
                  v-if="i.nodeType == 'APPROVAL' && i.selfSelect == 1"
                  size="mini"
                  icon="el-icon-plus"
              ></el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="j in i.AltUserList" :key="j.id" :command="j.id">{{ j.name }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 多选 -->
          <el-select
              style="width: 92%"
              size="mini"
              v-if="i.selectMode == 2 && i.nodeType == 'APPROVAL' && i.selfSelect == 1"
              v-model="ids"
              multiple
              placeholder="请选择审批人"
              @change="handleCommand1"
          >
            <el-option v-for="j in i.AltUserList" :key="j.id" :label="j.name" :value="j.id"/>
          </el-select>
        </el-timeline-item>
      </el-timeline>
      <div class="demo-drawer__footer" style="text-align: center; margin: 30px 0 20px">
        <el-button @click="Close">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" :disabled="submitLoading" @click="submitForm"
        >提 交
        </el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import InitiateProcess from './InitiateProcess'
import {
  getFormGroups,
  SubmitInstance,
  GetFlowInstancePage,
  GetFlowInstance,
  GetFlowInstanceCC,
  VerifyInstance,
  GetOpeateRecList,
  ExistInstance,
  GenerateInstance,
  InitFlowNode,
  SetCustomVerifiy,
  GetMakeCard,
  GetChangeApply,
  GetApply, goback,
} from '@/api/design'

export default {
  // 组件名称
  name: '',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {InitiateProcess},
  // 组件状态值
  data() {
    return {
      list: {},
      tptId: '',
      InitFlowNodeList: [],
      submitLoading: false,
      againShenPi: {},
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 2.初始化并加载审批节点(进度流程)
    initFlowNodeFun(val) {
      this.instanceId = this.tptId
      InitFlowNode({tptId: this.tptId}).then((res) => {
        if (res.code == 200) {
          console.log(res.data, '进度流程')
          this.InitFlowNodeList = res.data
          this.InitFlowNodeList.forEach((i) => {
            if (i.nodeType == 'APPROVAL') {
              i.name = i.makers.split(',').length + '人审批'
            }
            if (i.nodeType == 'CC') {
              i.name = '抄送' + i.makers.split(',').length + '人'
            }
            if (i.selfSelect == 1) {
              // 自选 =>设置自选审批人
              this.AltUserList = i.AltUserList
              // SetCustomVerifiy({ instanceId: val }).then((res) => {
              //   if (res.code == 200) {
              //     console.log(res.data, "自选审批人");
              //   }
              // });
            }
          })
        }
      })
    },
    Close() {
      // 返回上一页
      window.history.back()
    },
    submitForm() {
      this.submitLoading = true
      this.$refs.processForm.validate((valid) => {
        if (valid) {
          if (this.InitFlowNodeList.length > 0) {
            var formItems = this.$store.state.design.formItems
            for (let i = 0; i < formItems.length; i++) {
              const e = formItems[i]
              e.value = this.$store.state.formValue[e.id]
            }

            // return;
            for (var i = 0; i < this.InitFlowNodeList.length; i++) {
              if (this.InitFlowNodeList[i].nodeType == 'APPROVAL' && this.InitFlowNodeList[i].MakerIds == '') {
                this.$message({
                  message: '请选择审批人',
                  type: 'warning',
                })
                this.submitLoading = false
                return false
              }
            }
            let datas = document.getElementsByName("totalAmount");
            let params = {
                userId: this.$route.params.userId,
                nickName: this.$route.params.nickName,
                companyId: this.$route.params.companyId,
                platformId: this.$route.params.platformId,
                instanceId: this.instanceId,
                flag: 2,
                flowNodes: JSON.stringify(this.InitFlowNodeList),
                tptId: this.tptId,
                formData: JSON.stringify(this.$store.state.design.formItems),
            }
            if (datas.length > 0) {
              params = {
                totalAmount: datas[0].ariaValueNow,
                userId: this.$route.params.userId,
                nickName: this.$route.params.nickName,
                companyId: this.$route.params.companyId,
                platformId: this.$route.params.platformId,
                instanceId: this.instanceId,
                flag: 2,
                flowNodes: JSON.stringify(this.InitFlowNodeList),
                tptId: this.tptId,
                formData: JSON.stringify(this.$store.state.design.formItems),
              }
            }


            console.log('传参  params===', params)
            var path = '/approvalList/' +
                this.$route.params.userId +
                '/' +
                this.$route.params.platformId +
                '/' +
                this.$route.params.companyId +
                '/' +
                this.$route.params.nickName +
                "/" +
                3;
            SubmitInstance(params).then((res) => {
              if (res.code === 200) {
                this.$message({message: '发起成功', type: 'success'})
                // this.openItemDl = false;

                // 重新发起审批跳转OA页面
                if (this.isAgainShenPi) {
                  this.$router.push(path);
                } else {
                  // 正常流程
                  setTimeout(() => {
                    this.submitLoading = false
                    window.history.back()
                  }, 500)
                  this.$refs['processForm'].resetFields()
                  this.getGroups()
                }
              } else {
                this.submitLoading = false
                this.$message({
                  message: '操作失败, ' + res.msg,
                  type: 'error',
                })
              }
            })
          } else {
            this.submitLoading = false
            this.$message.warning('请先完善审批流程😥')
          }
        } else {
          this.submitLoading = false
          this.$message.warning('请完善表单😥')
        }
      })
    },
    resrtData(list) {
      let dataForm = {};
      let formData = JSON.parse(list.formData);
      dataForm.instanceId = this.$route.query.instanceId;
      dataForm.activiteId = this.$route.params.activiteId;
      dataForm.userId = this.$route.params.userId;
      dataForm.nickName = this.$route.params.nickName;
      dataForm.verifyFlag = 7;
      dataForm.result = 7;
      formData.forEach((i) => {
        console.log(i)
        i.value = this.$store.state.formValue[i.id];
      });
      dataForm.formData = JSON.stringify(formData);
      this.VerifyFun(dataForm)
    },
    async VerifyFun(dataForm) {
      await goback(dataForm);
      this.editLoading = false;
      this.$message({message: "操作成功", type: "success"});
    },

  },
  filters: {
    returnFloat(val) {
      if (val.length <= 2) {
        return val
      } else {
        return val.slice(-2)
      }
    },
    formatTime(val) {
      return val.split(' ')[0]
    },
  },
  created() {
  },
  mounted() {
    // console.log(this.$route.params.tptId, "模板id");
    this.tptId = this.$route.params.tptId
    this.initFlowNodeFun()
    if (this.$route.query.isAgainShenPi) {
      console.log('进来了吗')
      this.instanceId = this.$route.query.instanceId
      this.isAgainShenPi = true
      this.againShenPi = this.$route.query.shenPiListDetail
      // console.log('this.againShenPi---', this.againShenPi)
      //重新发起修改状态
      if (this.$route.query.list.result === 7) {
        this.resrtData(this.$route.query.list);
      }
    } else {
      this.isAgainShenPi = false
    }
  },
}
</script>

<style scoped>
.el-timeline-item {
  padding-bottom: 50px;
}

.markBox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 76%;
  float: right;
}

.Name {
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  background: #3c87f7;
  color: #fff;
  box-sizing: border-box;
  text-align: center;

  margin-bottom: 32px;
  margin-right: 18px;
}

/deep/ .el-timeline-item__tail {
  position: absolute;
  left: 4px;
  top: 16px;
  height: 80%;
}

/deep/ .el-timeline-item__node--normal {
  left: 1px;
  width: 8px;
  height: 8px;
}

.content {
  max-height: 100vh;
  background-color: #f7f7f7;
}

.mid {
  background-color: #fff;
  box-sizing: border-box;
  padding: 13px 14px;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #1e1e1e;
  margin-bottom: 12px;
}

.des {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  margin: 5px 0 7px;
}

/deep/ .el-timeline-item__content {
  font-family: PingFang SC;
  font-size: 13px;
  color: #1e1e1e;
  overflow: hidden;
}

/deep/ .el-timeline-item__timestamp {
  font-family: PingFang SC;
  font-size: 13px;
  color: #999999;
  position: absolute;
  left: 26px;
  top: 14px;
}
</style>
